import { withInstall } from '@jdesign-vue/utils'

import Icon from './src/icon.vue'

export const JdIcon = withInstall(Icon)
export default JdIcon

export * from './src/icon'
